import { createAction, props } from '@ngrx/store';
import { UserStats } from '../../modals/user.stats';

export const userStatsRequested = createAction(
    '[USER_STATS] Stats Requested',
    props<{ isRefreshRequired: boolean }>()
);

export const userStatsLoaded = createAction(
    '[USER_STATS] Stats Api Call',
    props<{ stats: UserStats, statsLoaded: boolean }>()
);

export const userStatsLoadingError = createAction(
    '[USER_STATS] Api Call Error',
    props<{ errorMessage: string }>()
);

export const userStatsResetRequested = createAction(
    '[USER_STATS] Reset Requested'
);

export const userStatsResetCompleted = createAction(
    '[USER_STATS] Reset Completed',
    props<{ stats: UserStats }>()
);